export const API_URL: string = process.env.REACT_APP_API_URL || 'https://api.getnovala.com';

export const FONT = "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif";